import { useContext, useEffect, useState } from 'react'
import { Outlet, useNavigate } from 'react-router-dom'
import utility from 'src/utils/utility'
import AppInfoContext from 'src/provider/state-manager/appInfoProvider'
import ApiContext from 'src/provider/API/call-service'
import access from 'src/utils/localAccess'
import { NotFound } from 'src/component'

export const MainRoutes = () => {
    const navigate = useNavigate()
    const {API} = useContext(ApiContext)
    const {info, recoverAppData, logout} = useContext(AppInfoContext)
    const [isAuth, setIsAuth] = useState<boolean>(!!info.authToken)
    const [showNotFound, setShowNotFound] = useState<boolean | null>(null)

    useEffect(() => {
        initializer()
    }, [])

    async function initializer () {
        access.setLogoutHandler(logout)
        access.setNavigationAccess(navigate)
        await recoverAppData(['theme', 'institutionData', 'hostName', 'alias'])
        if (!info.institutionData?.id) await API.getInstitution()
        handleAuth()
    }

    async function handleAuth () {
        let [authToken, institution]: any = await Promise.all([
            localStorage.getItem('authToken'),
            localStorage.getItem('institutionData')
        ])
        setShowNotFound(!JSON.parse(institution)?.id)
        
        if (!authToken) setIsAuth(!!authToken)
        else navigate('dashboard')
    }
    
    return (
        <>
            { (!isAuth && !showNotFound && showNotFound != null) ?
                    <Outlet />
                    :
                        showNotFound ? 
                            <NotFound />
                            : null
            }
        </>
    )
}

export default utility.routeData('/', 'Main', <MainRoutes/>)